import { SxProps } from '@mui/material';

export const superSkuBoxSX: SxProps = () => ({
	my: '5px',
	height: '24px',
	display: 'flex',
	alignItems: 'center',
});

export const superSkuLinkSX: SxProps = () => ({
	display: 'flex',
	alignItems: 'center',
	textDecoration: 'none',
	gap: 1,
});
